import React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

type FormRowProps = React.PropsWithChildren<{
  controlId: string;
  label: string;
  static?: boolean;
  labelSize?: number;
  valueSize?: number;
  alignRight?: boolean;
  className?: string;
}>;

const FormRowBase = (props: FormRowProps) => {
  return (
    <Form.Group
      as={Row}
      controlId={props.controlId}
      className={props.className}
    >
      <Form.Label column sm={props.labelSize || 3}>
        <div
          className={
            props.alignRight ? 'd-flex justify-content-end' : undefined
          }
        >
          {props.label}
        </div>
      </Form.Label>
      <Col
        sm={props.valueSize || 9}
        className={props.static ? 'col-form-static' : ''}
      >
        <div
          className={
            props.alignRight ? 'd-flex justify-content-end' : undefined
          }
        >
          {props.children}
        </div>
      </Col>
    </Form.Group>
  );
};

export const FormRow = (props: FormRowProps) => (
  <FormRowBase {...props} className="overflowx-clip" />
);

export const FormRow210 = (props: FormRowProps) => (
  <FormRowBase {...props} labelSize={2} valueSize={10} />
);

export const FormRow48 = (props: FormRowProps) => (
  <FormRowBase {...props} labelSize={4} valueSize={8} />
);

export const FormRow66 = (props: FormRowProps) => (
  <FormRowBase {...props} labelSize={6} valueSize={6} />
);

export const FormRow66R = (props: FormRowProps) => (
  <FormRowBase {...props} labelSize={6} valueSize={6} alignRight={true} />
);

export const FormRow84R = (props: FormRowProps) => (
  <FormRowBase {...props} labelSize={8} valueSize={4} alignRight={true} />
);

export const FormRow48R = (props: FormRowProps) => (
  <FormRowBase {...props} labelSize={4} valueSize={8} alignRight={true} />
);

export default FormRow;
